'use client';

import { useIntl } from 'react-intl';

import { Link } from '@packages/modules/src/Link/Link';

export const ProductStandardsHintLink = () => {
  const { formatMessage } = useIntl();

  const serviceLink = formatMessage({
    defaultMessage: '/service-hilfe/verantwortung ',
    id: 'productHintsAccordion.ecoLabels.hint.link.url',
  });

  return (
    <div className="text-size-body-sm">
      {formatMessage(
        {
          defaultMessage: 'Erfahre mehr zu unseren <link>Kriterien für Produktstandards</link>',
          id: 'productHintsAccordion.ecoLabels.hint.link',
        },
        {
          link: (chunks: React.ReactNode) => (
            <Link href={serviceLink} className="underline">
              {chunks}
            </Link>
          ),
        },
      )}
    </div>
  );
};
